import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCoreDetailsRoute: InvariantJiraRoute = {
	name: 'project-settings-core-details',
	path: '/jira/core/projects/:projectKey/settings/details',
	exact: true,
};
